<template>
  <div id="exploration-map-view">
    <router-link :to="{ name: 'Exploration', params: {id: exploration.id, mode: 'list'} }" class="btn btn-outline-primary btn-sm map-back-button"><i class="fal fa-arrow-left"></i> {{ exploration.title }}</router-link>
    <div id="exploration-map"></div><!-- /#exploration-map -->
  </div><!-- /#exploration-map -->
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: ['exploration'],
  created() {
    if (this.exploration.points) {
      this.initMap()
    }
  },
  watch: {
    exploration: function(newVal, oldVal) { // watch it
      this.initMap()
    }
  },
  methods: {
    initMap() {
      let explorationMap = []
      let self = this
      setTimeout(function () {
        // Configure map styles
        let mapStyles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]

        // Map properties
        explorationMap = new google.maps.Map(document.getElementById('exploration-map'), {
          center: {lat: 0, lng: 0},
          zoom: 2,
          styles: mapStyles,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false
        })

        var infowindow = new google.maps.InfoWindow()

        // Establish bounds
        let bounds = new google.maps.LatLngBounds()

        // Loop through points
        for (var i = 0; i < self.exploration.points.length; i++) {
          // Create the marker
          var marker = new google.maps.Marker({
            icon: {
              path: 'M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0',
              fillColor: '#2674a3',
              fillOpacity: 0.8,
              scale: 0.5,
              strokeColor: 'white',
              strokeWeight: 2
            },
            position: new google.maps.LatLng(self.exploration.points[i].coordinates.latitude, self.exploration.points[i].coordinates.longitude),
            map: explorationMap,
            title: self.exploration.points[i].title
          });

          // Extend bounds
          bounds.extend(new google.maps.LatLng(self.exploration.points[i].coordinates.latitude, self.exploration.points[i].coordinates.longitude))

          // Click event on marker
          google.maps.event.addListener(marker, 'click', (function(marker, i) {
            // Setup the infowindow
            let infowindowContent = '<div class="map-popup">' + self.exploration.points[i].title + '</div>'
            return function() {
              infowindow.setContent(infowindowContent)
              infowindow.open(explorationMap, marker)
            }
          })(marker, i))

          // End loop through points
        }

        // Set bounds
        explorationMap.fitBounds(bounds)
      }, 10)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ExplorationMap.vue